import api from './api';

export async function fetchRestaurant(slug) {
    if (!slug) return {};

    const { data } = await api.get(`restaurant/${slug}`);
    if (data) return data;
}

export async function fetchPaymentData(slug) {
    if (!slug) return {};

    const { data } = await api.get(`restaurant/${slug}/payment-settings`);
    if (data) return data;
}
